import CustomModal from 'components/global/CustomModal'
import React, { useState } from 'react'
import { eventCommonStore } from 'state/event/eventCommon'
import FaqModalContent from '../ModalCotent/FaqModalContent'
import CustomModalFooter from 'components/global/CustomModalFooter'
import AddQuestion from './AddQuestion'

interface FaqModalProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  organizationId: string
  referenceId: string
  reference: 'event' | 'league' | 'organization' | 'class'
  selectedFaqs: string[]
  setSelectedFaqs: (state: string[]) => void
}

const FaqModal: React.FC<FaqModalProps> = ({
  openModal,
  setOpenModal,
  organizationId,
  referenceId,
  reference,
  selectedFaqs,
  setSelectedFaqs,
}) => {
  const { addQuestionModal, setAddQuestionModal, setFaqData } =
    eventCommonStore(store => ({
      addQuestionModal: store.addQuestionModal,
      setAddQuestionModal: store.setAddQuestionModal,
      setFaqData: store.setFaqData,
    }))

  const handleSubmit = () => {
    setOpenModal(false)
  }

  const handleClose = () => {
    // Clear any FAQ left over from a previous Edit so "Add Question" always
    // opens in create mode instead of editing/overwriting the last FAQ.
    setFaqData(undefined)
    setAddQuestionModal(true)
  }

  return (
    <>
      <CustomModal
        openModal={openModal}
        isCloseModalCustom={true}
        closeModal={setOpenModal}
        title="FAQs"
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-between"
            btnText="Add Question,Submit"
            btnType="primary"
            closeModal={handleClose}
            onSubmit={handleSubmit}
          />
        }
      >
        <FaqModalContent
          organizationId={organizationId}
          referenceModalId={referenceId}
          reference={reference}
          selectedQuestion={selectedFaqs}
          setSelectedQuestion={setSelectedFaqs}
        />
      </CustomModal>

      {addQuestionModal && (
        <AddQuestion referenceModalId={referenceId} reference={reference} />
      )}
    </>
  )
}

export default FaqModal
